const ufeApi = require('services/api/ufeApi');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Sephora+Email+Subscription

function enrollToSephoraEmails(email) {
    const url = '/api/users/profile/emailSubscription';

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            body: JSON.stringify({ email })
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = enrollToSephoraEmails;
